import { render } from "./ArticleFamilies.vue?vue&type=template&id=4bce6668"
import script from "./ArticleFamilies.vue?vue&type=script&lang=js"
export * from "./ArticleFamilies.vue?vue&type=script&lang=js"

import "./ArticleFamilies.vue?vue&type=style&index=0&id=4bce6668&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__